import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  getBrowserLanguage(): string {
    return navigator.language || 'en'; // Default to 'en' if no language is detected
  }
}
